export default __webpack_public_path__ + "static/tractor1-d35844dfae75d348e0c484785eda2102.jpg";